import { ReportViewPageKeys } from "./keys";

export const englishValues = {
  [ReportViewPageKeys.reportsView_reportsBreadcrumb]: "Reports",
  [ReportViewPageKeys.reportsView_lastUpdatedString]: "Last updated",
  [ReportViewPageKeys.reportsView_totalString]: "Total",
  [ReportViewPageKeys.reportsView_completedString]: "Completed",
  [ReportViewPageKeys.reportsView_cancelledString]: "Cancelled",
  [ReportViewPageKeys.reportsView_completionRateString]: "Completion rate",
  [ReportViewPageKeys.reportsView_groupReportTab]: "Group Report",
  [ReportViewPageKeys.reportsView_individualsReportTab]: "Individuals Report",
  [ReportViewPageKeys.reportsView_teamReportTab]: "Team Report",
  [ReportViewPageKeys.reportsView_clearButton]: "clear",
  [ReportViewPageKeys.reportsView_selectFromListBelow]: "Select from the list below",
  [ReportViewPageKeys.reportsView_invalidSurveyCampaign]: "Invalid survey campaign",
};

export const malayValues = {
  [ReportViewPageKeys.reportsView_reportsBreadcrumb]: "Laporan",
  [ReportViewPageKeys.reportsView_lastUpdatedString]: "Dikemas kini pada",
  [ReportViewPageKeys.reportsView_totalString]: "Jumlah",
  [ReportViewPageKeys.reportsView_completedString]: "Dilengkapkan",
  [ReportViewPageKeys.reportsView_cancelledString]: "Dibatalkan",
  [ReportViewPageKeys.reportsView_completionRateString]: "Kadar pelengkapan",
  [ReportViewPageKeys.reportsView_groupReportTab]: "Laporan Kumpulan",
  [ReportViewPageKeys.reportsView_individualsReportTab]: "Laporan Individu",
  [ReportViewPageKeys.reportsView_teamReportTab]: "Laporan Pasukan",
  [ReportViewPageKeys.reportsView_clearButton]: "kosongkan",
  [ReportViewPageKeys.reportsView_selectFromListBelow]: "Pilih daripada senarai di bawah",
  [ReportViewPageKeys.reportsView_invalidSurveyCampaign]: "Kempen tinjauan tidak sah",
};

export const chineseSimplifiedValues = {
  [ReportViewPageKeys.reportsView_reportsBreadcrumb]: "报告",
  [ReportViewPageKeys.reportsView_lastUpdatedString]: "更新时间",
  [ReportViewPageKeys.reportsView_totalString]: "总数",
  [ReportViewPageKeys.reportsView_completedString]: "已完成",
  [ReportViewPageKeys.reportsView_cancelledString]: "已取消",
  [ReportViewPageKeys.reportsView_completionRateString]: "完成率",
  [ReportViewPageKeys.reportsView_groupReportTab]: "组报告",
  [ReportViewPageKeys.reportsView_individualsReportTab]: "个人报告",
  [ReportViewPageKeys.reportsView_teamReportTab]: "团队报告",
  [ReportViewPageKeys.reportsView_clearButton]: "清除",
  [ReportViewPageKeys.reportsView_selectFromListBelow]: "从下方列表中选择",
  [ReportViewPageKeys.reportsView_invalidSurveyCampaign]: "无效的调查活动",
};

export const chineseTraditionalValues = {
  [ReportViewPageKeys.reportsView_reportsBreadcrumb]: "報告",
  [ReportViewPageKeys.reportsView_lastUpdatedString]: "更新時間",
  [ReportViewPageKeys.reportsView_totalString]: "總數",
  [ReportViewPageKeys.reportsView_completedString]: "已完成",
  [ReportViewPageKeys.reportsView_cancelledString]: "已取消",
  [ReportViewPageKeys.reportsView_completionRateString]: "完成率",
  [ReportViewPageKeys.reportsView_groupReportTab]: "組報告",
  [ReportViewPageKeys.reportsView_individualsReportTab]: "個人報告",
  [ReportViewPageKeys.reportsView_teamReportTab]: "團隊報告",
  [ReportViewPageKeys.reportsView_clearButton]: "清除",
  [ReportViewPageKeys.reportsView_selectFromListBelow]: "從下方列表中選擇",
  [ReportViewPageKeys.reportsView_invalidSurveyCampaign]: "無效的調查活動",
};
